(() => {
  const ODD_ROOT_SELECTOR = ".identixweb-order-delivery";
  const CART_ITEM_SELECTOR = "[data-product-tags]";
  const SPECIAL_FLASH_TAG = "flash-special";

  let __fzbPersistT = null;
  let __fzbLastPayloadKey = "";
  let __fzbApplying = false;

  function persistCartAttributes(attrs, { remove = [] } = {}) {
    const payload = { attributes: { ...attrs } };
    remove.forEach((k) => (payload.attributes[k] = null));

    const key = JSON.stringify(payload);
    if (key === __fzbLastPayloadKey) return Promise.resolve();
    __fzbLastPayloadKey = key;

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    }).then((r) => r.json());
  }

  function debouncePersist(attrs, opts) {
    clearTimeout(__fzbPersistT);
    __fzbPersistT = setTimeout(() => {
      persistCartAttributes(attrs, opts).catch((e) =>
        console.warn("[FLASH/ZERO] persistCartAttributes error", e)
      );
    }, 120);
  }

  function getCartTagState() {
    const rows = document.querySelectorAll(CART_ITEM_SELECTOR);

    let hasFlash = false;
    let hasZero = false;
    let hasNormal = false;
    let hasFlashSpecial = false;

    rows.forEach((row) => {
      const raw = row.getAttribute("data-product-tags") || "";
      if (!raw.trim()) return;

      const tags = raw
        .split(",")
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean);

      const isFlash = tags.includes("flash");
      const isZero = tags.includes("zero waste");
      const isFlashSpecial = tags.includes(SPECIAL_FLASH_TAG);
      const isFlashOrZero = isFlash || isZero || isFlashSpecial;

      if (isFlash) hasFlash = true;
      if (isZero) hasZero = true;
      if (isFlashSpecial) {
        hasFlash = true;
        hasFlashSpecial = true;
      }

      if (!isFlashOrZero) hasNormal = true;
    });

    const hasFlashZero = hasFlash || hasZero || hasFlashSpecial;

    return { hasFlash, hasZero, hasFlashZero, hasNormal, hasFlashSpecial };
  }

  function nextFriday() {
    const d = new Date();
    const day = d.getDay();
    const diff = (5 - day + 7) % 7 || 7;
    d.setDate(d.getDate() + diff);
    return d;
  }

  function getForcedDeliveryDate(hasFlashSpecial) {
    if (hasFlashSpecial) {
      return new Date(2026, 5, 18); // Miércoles 17/06/2026
    }

    return nextFriday();
  }

  function getForcedDeliveryDay(hasFlashSpecial) {
    return hasFlashSpecial ? "Jueves" : "Viernes";
  }

  function formatDDMMYY(date) {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  }

  function ensureFlashZeroOrderAttributeInput(dateStr, dayLabel) {
    const form = document.querySelector("form#cart-form");
    if (!form) return;

    let input = form.querySelector('input[name="attributes[Entrega Flash/Zero]"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "attributes[Entrega Flash/Zero]";
      form.appendChild(input);
    }

    input.value = `${dayLabel} (${dateStr})`;
  }

  function removeFlashZeroOrderAttributeInput() {
    const form = document.querySelector("form#cart-form");
    const input = form?.querySelector('input[name="attributes[Entrega Flash/Zero]"]');
    input?.remove();
  }

  function setOddHiddenAttributesToForcedDate(root, hasFlashSpecial) {
    const date = getForcedDeliveryDate(hasFlashSpecial);
    const dateStr = formatDDMMYY(date);
    const dayLabel = getForcedDeliveryDay(hasFlashSpecial);

    const inputDate = root.querySelector('input[name="attributes[Fecha de entrega]"]');
    const inputDay = root.querySelector('input[name="attributes[Dia de entrega]"]');
    const inputFormat = root.querySelector('input[name="attributes[Date Format]"]');

    if (inputFormat) inputFormat.value = "dd/mm/yy";
    if (inputDate) inputDate.value = dateStr;
    if (inputDay) inputDay.value = dayLabel;

    [inputDate, inputDay, inputFormat].filter(Boolean).forEach((el) => {
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });

    return { dateStr, dayLabel };
  }

  function getMessageHost() {
    const oddMain =
      document.querySelector(".identixweb-order-delivery-date-main") ||
      document.querySelector(ODD_ROOT_SELECTOR);

    if (!oddMain) return null;

    let host = oddMain.querySelector("#flash-zero-delivery-message");

    if (!host) {
      host = document.createElement("div");
      host.id = "flash-zero-delivery-message";
      host.className = "cart-drawer__delivery-message";
      host.setAttribute("data-flash-zero-message", "true");
      oddMain.appendChild(host);
    }

    const duplicates = oddMain.querySelectorAll('[data-flash-zero-message="true"]');
    duplicates.forEach((el, index) => {
      if (index > 0) el.remove();
    });

    return host;
  }

  function ensureMessage(text) {
    const host = getMessageHost();
    if (!host) return;

    host.hidden = false;
    host.textContent = text;

    host.style.margin = "12px 16px 0";
    host.style.padding = "10px 12px";
    host.style.borderRadius = "10px";
    host.style.fontSize = "14px";
    host.style.fontWeight = "600";
    host.style.background = "rgba(0,0,0,0.04)";
  }

  function hideMessage() {
    document
      .querySelectorAll('[data-flash-zero-message="true"]')
      .forEach((el) => {
        el.hidden = true;
        el.textContent = "";
      });
  }

  function getFlashZeroLabel({ hasFlash, hasZero, hasFlashSpecial }) {
    if (hasFlashSpecial) return "Flash";
    if (hasFlash && hasZero) return "Flash y Zero Waste";
    if (hasFlash) return "Flash";
    if (hasZero) return "Zero Waste";
    return "";
  }

  function setFridaysDisabledInRMDP(root, disabled) {
    const wrap = root.querySelector(".rmdp-wrapper");
    if (!wrap) return;

    if (!wrap.dataset.fzbInit) {
      wrap.dataset.fzbInit = "1";

      wrap.addEventListener(
        "click",
        (e) => {
          if (wrap.dataset.fzbDisableFridays !== "1") return;

          const dayEl = e.target.closest(".rmdp-day");
          if (!dayEl) return;

          const week = dayEl.closest(".rmdp-week");
          if (!week) return;
          if (week.querySelector(".rmdp-week-day")) return;

          const days = Array.from(week.querySelectorAll(":scope > .rmdp-day"));
          const idx = days.indexOf(dayEl);

          if (idx === 4) {
            e.preventDefault();
            e.stopPropagation();
            ensureMessage(
              "Para estas cajas no se entrega en viernes. Elige martes, miércoles o jueves."
            );
          }
        },
        true
      );

      const obs = new MutationObserver(() => applyDisable());
      obs.observe(wrap, { childList: true, subtree: true });
    }

    wrap.dataset.fzbDisableFridays = disabled ? "1" : "0";

    function applyDisable() {
      const weeks = wrap.querySelectorAll(".rmdp-week");

      weeks.forEach((week) => {
        if (week.querySelector(".rmdp-week-day")) return;

        const days = week.querySelectorAll(":scope > .rmdp-day");
        if (!days || days.length < 5) return;

        const friday = days[4];
        if (!friday) return;
        if (friday.classList.contains("rmdp-day-hidden")) return;

        wrap.setAttribute("data-fzb-disable-fridays", wrap.dataset.fzbDisableFridays);

        if (wrap.dataset.fzbDisableFridays === "1") {
          if (!friday.classList.contains("rmdp-disabled")) {
            friday.classList.add("rmdp-disabled");
            friday.dataset.fzbAddedDisabled = "1";
          }

          friday.style.pointerEvents = "none";
          friday.setAttribute("aria-disabled", "true");
        } else {
          if (friday.dataset.fzbAddedDisabled === "1") {
            friday.classList.remove("rmdp-disabled");
            delete friday.dataset.fzbAddedDisabled;
          }

          friday.style.pointerEvents = "";
          friday.removeAttribute("aria-disabled");
        }
      });
    }

    applyDisable();
  }

  function apply() {
    const root = document.querySelector(ODD_ROOT_SELECTOR);
    if (!root) return;

    const { hasFlash, hasZero, hasFlashZero, hasNormal, hasFlashSpecial } =
      getCartTagState();

    const calendarWrap = root.querySelector(".shipping-identixweb-order-delivery-dates");
    const noteDiv = root.querySelector(".note_div");
    const requiredText = root.querySelector(".deliveryRequired");
    const unavailableText = root.querySelector(
      ".identixweb-order-delivery-date-deliveryRequired"
    );

    if (!calendarWrap) return;

    if (!hasFlashZero) {
      calendarWrap.style.display = "";
      if (noteDiv) noteDiv.style.display = "";
      if (requiredText) requiredText.style.display = "";
      if (unavailableText) unavailableText.style.display = "";

      setFridaysDisabledInRMDP(root, true);

      hideMessage();
      removeFlashZeroOrderAttributeInput();

      debouncePersist(
        {},
        {
          remove: [
            "Entrega Flash/Zero",
            "Fecha entrega Flash/Zero",
            "Dia entrega Flash/Zero",
            "Formato entrega Flash/Zero",
          ],
        }
      );
      return;
    }

    const forcedDate = getForcedDeliveryDate(hasFlashSpecial);
    const dateStr = formatDDMMYY(forcedDate);
    const dayLabel = getForcedDeliveryDay(hasFlashSpecial);

    ensureFlashZeroOrderAttributeInput(dateStr, dayLabel);

    const label = getFlashZeroLabel({ hasFlash, hasZero, hasFlashSpecial });

    if (hasNormal) {
      calendarWrap.style.display = "";
      if (noteDiv) noteDiv.style.display = "";
      if (requiredText) requiredText.style.display = "";
      if (unavailableText) unavailableText.style.display = "";

      setFridaysDisabledInRMDP(root, true);

      ensureMessage(
        `Tu caja ${label} se entregará el ${dayLabel.toLowerCase()} (${dateStr}). Elige fecha para el resto de cajas.`
      );

      debouncePersist({
        "Entrega Flash/Zero": `${dayLabel} (${dateStr})`,
      });

      return;
    }

    setFridaysDisabledInRMDP(root, false);

    const forced = setOddHiddenAttributesToForcedDate(root, hasFlashSpecial);

    calendarWrap.style.display = "none";
    if (noteDiv) noteDiv.style.display = "none";
    if (requiredText) requiredText.style.display = "none";
    if (unavailableText) unavailableText.style.display = "none";

    ensureMessage(
      `Esta caja ${label ? `(${label}) ` : ""}se entregará el ${forced.dayLabel.toLowerCase()} (${forced.dateStr}).`
    );

    debouncePersist({
      "Fecha entrega Flash/Zero": forced.dateStr,
      "Dia entrega Flash/Zero": forced.dayLabel,
      "Formato entrega Flash/Zero": "dd/mm/yy",
      "Entrega Flash/Zero": `${forced.dayLabel} (${forced.dateStr})`,
    });
  }

  function runApplySafely() {
    if (__fzbApplying) return;

    __fzbApplying = true;
    try {
      window.applyDeliveryRulesForFlashZero?.();
    } finally {
      setTimeout(() => {
        __fzbApplying = false;
      }, 300);
    }
  }

  function hookCartChanges() {
    const container =
      document.querySelector("cart-drawer-component dialog.cart-drawer__dialog") ||
      document.querySelector("form#cart-form") ||
      document.querySelector("body");

    if (!container) return;

    const obs = new MutationObserver(() => {
      clearTimeout(window.__fzbApplyT);
      window.__fzbApplyT = setTimeout(() => {
        runApplySafely();
      }, 80);
    });

    obs.observe(container, { childList: true, subtree: true });
  }

  window.applyDeliveryRulesForFlashZero = function () {
    apply();
    setTimeout(apply, 50);
    setTimeout(apply, 250);
    setTimeout(apply, 800);
    setTimeout(apply, 1500);
  };

  function hookCartDrawerOpen() {
    const dialog = document.querySelector("cart-drawer-component dialog.cart-drawer__dialog");
    if (!dialog) return;

    dialog.addEventListener("toggle", () => {
      if (!dialog.open) return;
      runApplySafely();
    });
  }

  hookCartDrawerOpen();
  hookCartChanges();
  runApplySafely();
})();